import React from "react";
import PlatformNewsArticleHeader from "../components/PlatformNewsArticleHeader";
import PlatformNewsArticleSection from "../components/PlatformNewsArticleSection";
import PlatformNewsCallout from "../components/PlatformNewsCallout";
import PlatformNewsFeatureGrid from "../components/PlatformNewsFeatureGrid";
import {
    expeditorProDiscountOffer,
} from "../../../../content/platform-news/offers";

const audienceItems = [
    "Компании, выполняющие перевозки собственным транспортом.",
    "Экспедиторы, привлекающие сторонних перевозчиков.",
    "Агенты и посредники, участвующие в логистических цепочках.",
];

const storageItems = [
    "сведения о клиентах и контрагентах, включая изменения регистрационных данных;",
    "все договоры и информация о грузах: наименование, вес, объём, категория и опасность;",
    "маршруты, виды транспорта и участники перевозки;",
    "все операции с грузом: приём, погрузка, перегрузка, хранение, выгрузка и передача;",
    "финансовые расчёты по договорам;",
    "логи действий пользователей в информационных системах: IP-адреса, время сессий и совершённые операции.",
];

const solutionItems = [
    {
        title: "Единый контур и хранение в РФ",
        text: "Все рейсы, контрагенты, водители и документы собираются в одной системе, развёрнутой на защищённых российских серверах.",
    },
    {
        title: "Хранение на серверах в РФ",
        text: "Наши мощности находятся на территории России — это прямое соответствие закону о локализации данных.",
    },
    {
        title: "Встроенный ЭДО и ЭТрН",
        text: "Документы подписываются через операторов СБИС, Контур и Астрал. Данные автоматически архивируются и сохраняются на требуемый законом срок.",
    },
    {
        title: "Автоматическая отчётность для ГосЛог",
        text: "Мы интегрированы с государственным реестром экспедиторов и формируем отчёты по утверждённым форматам — заполнять их вручную не требуется.",
    },
    {
        title: "Готовность к СОРМ и ГосЛог",
        text: "Мы участвуем в рабочих группах и разрабатываем модуль для бесшовного подключения к СОРМ. После утверждения технических требований пользователи получат готовое решение без дополнительных затрат на оборудование и сторонних подрядчиков.",
    },
];

const tariffItems = [
    {
        title: "Доступ к бирже заказов",
        text: "Более 200 свежих рейсов от грузовладельцев ежедневно.",
    },
    {
        title: "Мультиаккаунт",
        text: "Возможность брать чужие заказы и одновременно привлекать перевозчиков на собственные рейсы.",
    },
    {
        title: "Готовый модуль ФСБ и СОРМ",
        text: "Техническая обвязка и хранение данных уже включены в подписку.",
    },
    {
        title: "Автоматизация документооборота",
        text: "ЭТрН, счета и акты формируются автоматически и подписываются через ЭДО.",
    },
    {
        title: "Контроль и аналитика",
        text: "Все рейсы, статусы и финансовые показатели доступны в реальном времени.",
    },
];

const penaltyRows = [
    {
        violation: "Работа без записи в реестре ГосЛог",
        article: "Федеральный закон № 87-ФЗ",
        consequences: [
            "Прямой запрет на оказание транспортно-экспедиционных услуг.",
        ],
    },
    {
        violation: "Отсутствие СОРМ и непредоставление данных ФСБ",
        article: "ч. 2 ст. 13.31 КоАП РФ",
        consequences: [
            "Для юридических лиц: от 800 000 до 1 000 000 рублей.",
            "Для должностных лиц: от 30 000 до 50 000 рублей.",
        ],
    },
    {
        violation: "Непредоставление ключей шифрования или декодирования",
        article: "ч. 2.1 ст. 13.31 КоАП РФ",
        consequences: [
            "Для юридических лиц: от 800 000 до 1 000 000 рублей.",
            "Для должностных лиц: от 30 000 до 50 000 рублей.",
        ],
    },
    {
        violation: "Неуведомление Роскомнадзора о начале деятельности",
        article: "ч. 1 и ч. 1.1 ст. 13.31 КоАП РФ",
        consequences: [
            "Первичное нарушение для юридических лиц: от 100 000 до 300 000 рублей.",
            "Повторное нарушение для юридических лиц: от 500 000 до 1 000 000 рублей.",
        ],
    },
    {
        violation: "Неустранение нарушений",
        article: "ч. 44 ст. 19.5 КоАП РФ",
        consequences: [
            "Для юридических лиц: от 500 000 до 1 000 000 рублей.",
        ],
    },
];

export default function FsbSorm2026Article({
                                               newsItem,
                                           }) {
    return (
        <article className="platform-news-article">
            <PlatformNewsArticleHeader
                newsItem={newsItem}
                subtitle="Готовое решение от «Светофор Логистика»"
            />

            <div className="platform-news-article__lead">
                <p>
                    С 2026 года правила игры на транспортно-экспедиционном
                    рынке кардинально изменились. Мало того, что все
                    экспедиторы обязаны состоять в государственном реестре
                    — теперь к этому добавились жёсткие требования по
                    взаимодействию с ФСБ и организации системы хранения
                    данных.
                </p>

                <p>
                    Если раньше регуляторные нормы казались чем-то далёким,
                    то сегодня затягивание процессов ведёт к реальным штрафам
                    и риску приостановки деятельности.
                </p>

                <p>
                    Разбираем, кого касаются новые правила, что требует закон
                    и как «Светофор Логистика» помогает закрыть эти задачи
                    под ключ, не раздувая IT-бюджеты.
                </p>
            </div>

            <PlatformNewsArticleSection
                icon="⚖️"
                title="Кого касаются новые требования?"
            >
                <p>
                    Всех юридических лиц и индивидуальных предпринимателей,
                    которые организуют или сопровождают грузоперевозки.
                    Главный критерий — фактическое оказание
                    транспортно-экспедиционных услуг. Код ОКВЭД значения
                    не имеет.
                </p>

                <ul className="platform-news-article__list">
                    {audienceItems.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            </PlatformNewsArticleSection>

            <PlatformNewsArticleSection
                icon="📌"
                title="3 ключевые обязанности экспедитора"
            >
                <div
                    className="platform-news-article__steps"
                    role="list"
                >
                    <div
                        className="platform-news-article__step"
                        role="listitem"
                    >
                        <span
                            className="platform-news-article__step-number"
                            aria-hidden="true"
                        >
                            01
                        </span>

                        <div className="platform-news-article__step-content">
                            <h4>Нахождение в реестре экспедиторов</h4>

                            <p>
                                Все экспедиторы должны состоять в
                                государственном реестре. Работа вне реестра
                                является нарушением законодательства.
                                «Светофор Логистика» помогает клиентам
                                корректно заполнять отчётность и снижать
                                юридические риски.
                            </p>
                        </div>
                    </div>

                    <div
                        className="platform-news-article__step"
                        role="listitem"
                    >
                        <span
                            className="platform-news-article__step-number"
                            aria-hidden="true"
                        >
                            02
                        </span>

                        <div className="platform-news-article__step-content">
                            <h4>Взаимодействие с ФСБ и СОРМ</h4>

                            <p>
                                После включения в реестр компания должна
                                наладить взаимодействие с территориальными
                                органами ФСБ.
                            </p>

                            <div className="platform-news-article__step-points">
                                <div className="platform-news-article__step-point">
                                    Подать заявление о начале взаимодействия
                                    в течение 45 дней.
                                </div>

                                <div className="platform-news-article__step-point">
                                    Согласовать план внедрения технических
                                    средств СОРМ.
                                </div>

                                <div className="platform-news-article__step-point">
                                    Установить и запустить систему.
                                </div>

                                <div className="platform-news-article__step-point">
                                    Установить оборудование и пройти
                                    приёмо-сдаточные испытания.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="platform-news-article__step"
                        role="listitem"
                    >
                        <span
                            className="platform-news-article__step-number"
                            aria-hidden="true"
                        >
                            03
                        </span>

                        <div className="platform-news-article__step-content">
                            <h4>
                                Хранение данных не менее трёх лет на
                                серверах в РФ
                            </h4>

                            <p>
                                Закон требует фиксировать и хранить следующие
                                сведения:
                            </p>

                            <div className="platform-news-article__step-points">
                                {storageItems.map((item) => (
                                    <div
                                        className="platform-news-article__step-point"
                                        key={item}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>

                            <p className="platform-news-article__notice">
                                Реализовать такой сбор вручную или в
                                Excel-таблицах физически невозможно.
                            </p>
                        </div>
                    </div>
                </div>
            </PlatformNewsArticleSection>

            <PlatformNewsArticleSection
                icon="🚫"
                title="Последствия и штрафы"
            >
                <div className="platform-news-article__table-wrapper">
                    <table className="platform-news-article__table">
                        <thead>
                        <tr>
                            <th>Нарушение</th>
                            <th>Основание</th>
                            <th>Последствия и штраф</th>
                        </tr>
                        </thead>

                        <tbody>
                        {penaltyRows.map((row) => (
                            <tr key={row.violation}>
                                <td>{row.violation}</td>
                                <td>{row.article}</td>
                                <td>
                                    {row.consequences.map((item) => (
                                        <p key={item}>{item}</p>
                                    ))}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </PlatformNewsArticleSection>

            <PlatformNewsArticleSection
                icon="🛡️"
                title="Как «Светофор Логистика» решает эти задачи"
            >
                <p>
                    Мы создали систему, которая снимает с экспедитора
                    необходимость настройки сложной IT-инфраструктуры,
                    объединяя безопасность с практической пользой для
                    бизнеса.
                </p>

                <PlatformNewsFeatureGrid
                    items={solutionItems}
                    marker="check"
                />
            </PlatformNewsArticleSection>

            <PlatformNewsArticleSection
                icon="💼"
                title="Тариф «Экспедитор Про»"
            >
                <p>
                    Юридический модуль и инструменты для работы с заказами
                    объединены в специальном тарифе «Экспедитор Про».
                </p>

                <PlatformNewsFeatureGrid
                    items={tariffItems}
                    marker="check"
                    variant="tariff"
                />
            </PlatformNewsArticleSection>

            <PlatformNewsCallout
                callout={expeditorProDiscountOffer}
            />

            <p className="platform-news-article__disclaimer">
                Статья носит информационный характер. Для учёта
                индивидуальных особенностей вашей компании рекомендуем
                проконсультироваться с профильным юристом.
            </p>
        </article>
    );
}
